import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const EyeIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 30, height = 30, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.7274 15C12.7274 15.6268 12.9765 16.228 13.4197 16.6713C13.863 17.1146 14.4642 17.3636 15.0911 17.3636C15.718 17.3636 16.3192 17.1146 16.7624 16.6713C17.2057 16.228 17.4547 15.6268 17.4547 15C17.4547 14.3731 17.2057 13.7719 16.7624 13.3286C16.3192 12.8854 15.718 12.6363 15.0911 12.6363C14.4642 12.6363 13.863 12.8854 13.4197 13.3286C12.9765 13.7719 12.7274 14.3731 12.7274 15Z"
          stroke="white"
          strokeOpacity="0.65"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.7274 15C22.8911 19.7272 19.3456 22.0909 15.0911 22.0909C10.8365 22.0909 7.29108 19.7272 4.45471 15C7.29108 10.2727 10.8365 7.90906 15.0911 7.90906C19.3456 7.90906 22.8911 10.2727 25.7274 15Z"
          stroke="white"
          strokeOpacity="0.65"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
